import React, { ReactText } from 'react';
import { Chart } from 'react-google-charts';
import { capitalizeData } from 'spw-shared/utils';
import _ from 'lodash';

export interface SmallDonutChartProps {
  data: ReactText[][];
  colors?: string[];
  pieHole?: number;
  options?: {
    width: number;
    height: number;
  };
}

const SmallDonutChart: React.FunctionComponent<SmallDonutChartProps> = ({
  data,
  colors,
  pieHole = 0.7,
  options = {},
}) => {
  let dataFinal = data;
  let colorsFinal = colors;

  // Generate single-grey value if all values are 0
  if (
    _.every(data, (entry) => entry[1] === 0 || typeof entry[1] === 'string')
  ) {
    dataFinal = [
      ['Space Type', 'Count'],
      ['empty', 1],
    ];
    colorsFinal = ['#EEEEEE'];
  }

  return (
    <Chart
      className="small-donut-chart"
      chartType="PieChart"
      loader={<div>Loading Chart</div>}
      data={capitalizeData(dataFinal)}
      options={{
        height: 90,
        width: 90,
        pieSliceText: 'none',
        legend: 'none',
        pieHole,
        chartArea: { width: '100%', height: '100%', left: '0%', top: '0%' },
        enableInteractivity: false,
        colors: colorsFinal,
        backgroundColor: 'transparent',
        pieStartAngle: 0,
        ...options,
      }}
    />
  );
};

export default SmallDonutChart;
